<template>
  <board-member-create-form
    :id="id"
    :editMode="true"
  ></board-member-create-form>
</template>

<script>
import BoardMemberCreateForm from "./CreateForm";
export default {
  name: "EditBoardMemberPage",
  components: { BoardMemberCreateForm },
  data() {
    return {
      id: null
    };
  },
  created() {
    this.id = this.$route.params.id;
  }
};
</script>

<style scoped></style>
